import { observer } from 'mobx-react-lite';
import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '~/app/app.routes';

export const IndexPage = observer(() => {
	const nav = useNavigate();

	useLayoutEffect(() => {
		nav(AppRoutes.DashboardGeneral.path);
	}, [nav]);

	return null;
});
